const CONTROLLER_EVENT = {
    LOADED: 'loaded',
    READY: 'ready',
    PLAY: 'play',
    PAUSE: 'pause',
    ERROR: 'error',
    DONE: 'done',
};

export default CONTROLLER_EVENT;